export enum PricingCycleUnit {
  PER_UNIT = 'per_unit',
  ONE_TIME = 'one_time',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  QUARTERLY = 'quarterly',
  CUSTOM = 'custom',
}
